class HeroGrid extends HTMLElement {
  constructor() {
    super();
    this.grid = this.querySelector('.hero-grid__grid');
    this.videos = this.querySelectorAll('video');
    this.progressBar = this.parentElement.querySelector('.hero-grid__bar');
    
    if (!this.grid) return;

    this.initObserver();
    
    if (this.progressBar) {
      this.initScrollProgress();
    }
  }

  initObserver() {
    const isMobile = window.innerWidth < 750;
    
    // On Mobile TikTok mode, the grid IS the scroller.
    const observerRoot = isMobile ? this.grid : null;

    const options = {
      root: observerRoot,
      threshold: 0.6
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          this.playVideo(video);
        } else {
          this.pauseVideo(video);
        }
      });
    }, options);

    this.videos.forEach((video) => observer.observe(video));
  }

  playVideo(video) {
    if (video.paused) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch((e) => console.log('Autoplay blocked:', e));
      }
    }
  }

  pauseVideo(video) {
    if (!video.paused) {
      video.pause();
    }
  }

  initScrollProgress() {
    this.grid.addEventListener('scroll', () => {
      const maxScroll = this.grid.scrollWidth - this.grid.clientWidth;
      if (maxScroll <= 0) return;
      const percentage = (this.grid.scrollLeft / maxScroll) * 100;
      this.progressBar.style.width = `${percentage}%`;
    });
  }
}

customElements.define('hero-grid', HeroGrid);